import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CheckboxEntityTypeObj } from './Filter.interface';
import { DisplayInputValue } from '../ProviderAutocomplete/AutocompleteInput/AutocompleteInput';
import { loadValueSet } from './Filter.mock';

const useMultiSelection = (initialStatement: CheckboxEntityTypeObj[], valueSetName: string) => {
  const [totalEntities, setTotalEntities] = useState<DisplayInputValue[]>([]);
  const [checkedEntity, setCheckedEntity] = useState<CheckboxEntityTypeObj[]>([]);
  const { getAccessTokenSilently } = useAuth0();
  const onChangeHandler = (value: CheckboxEntityTypeObj[]) => setCheckedEntity(value);

  useEffect(() => {
    setCheckedEntity(initialStatement);
  }, [initialStatement]);

  useEffect(() => {
    const setToken = async () => {
      const accessToken = await getAccessTokenSilently();
      loadValueSet(valueSetName, accessToken)
        .then((response) => setTotalEntities(response))
        .catch((e) => console.log(e)); // eslint-disable-line no-console
    };
    setToken();
  }, [valueSetName, getAccessTokenSilently]);

  return {
    checkedEntity,
    onChangeHandler,
    totalEntities,
  };
};

export default useMultiSelection;
